module.exports = __webpack_public_path__ + "static/media/gs.21f7c99f.svg";